module.exports = __webpack_public_path__ + "static/media/joined.328cbe2a.svg";